<template>
  <div class="author">
    <div class="author_nav">
      <div class="topTop">
        <div class="banner">
          <el-carousel
            ref="carousel"
            style="width: 100%"
            :index="mrIndex"
            trigger="click"
            arrow="never"
            ndicator-position="none"
          >
            <el-carousel-item v-for="(item, index) in tu" :key="index">
              <img class="imgggg" :src="item.titlePhoto" @click="linkUrl(item.linkurl)" />
            </el-carousel-item>
          </el-carousel>
        </div>

        <div class="topRight">
          <div class="topMap">
            <img src="../../../assets/rmts.png" alt="" />
          </div>

          <div
            :class="item.zt ? 'add2' : ''"
            class="topMain"
            @mouseover="addtop(1, item.id, index)"
            @mouseout="addtop(2, item.id, index)"
            v-for="(item, index) in list2"
          >
            <img :src="item.img" alt="" />
            <li>
              {{ item.title }}
              <span>></span>
            </li>
          </div>
        </div>
      </div>

      <div class="phone" v-for="(item, index) in title">
        <div
          @click="goNext(item.mainTitle, item.goNext, item)"
          style="cursor: pointer"
          class="phoneTop"
        >
          <img :src="item.img" alt="" />
          <h3>{{ item.mainTitle }}</h3>
        </div>

        <span style="color: #7a89a3">{{ item.message }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      num: 1, //1.在线发表 2.精华集萃 3.热门文献 4.研究快讯
      mrIndex: 0,
      title: [
        {
          //  img:"",
          img: require("../../../assets/zztg.png"),
          mainTitle: "作者投稿",
          message: "在线投稿 查询便捷",
          goNext: "http://www.chinacirculation.org/Admin/",
          path: "/checkout",
        },
        {
          img: require("../../../assets/zxbj.png"),
          mainTitle: "在线编辑",
          message: "在线办公 查询便捷",
          goNext: "http://www.chinacirculation.org/Admin/",
          path: "/checkout",
        },
        {
          img: require("../../../assets/zxcg.png"),
          mainTitle: "在线查稿",
          message: "在线投稿 查询便捷",
          goNext: "http://www.chinacirculation.org/Admin/",
          path: "/checkout",
        },
        {
          img: require("../../../assets/zjsg.png"),
          mainTitle: "专家审稿",
          message: "在线投稿 查询便捷",
          goNext: "http://www.chinacirculation.org/Admin/",
          path: "/checkout",
        },
        {
          img: require("../../../assets/zxdy.png"),
          mainTitle: "在线订阅",
          message: "在线投稿 查询便捷",
          goNext: "http://subscribe.boyuancb.com/",
        },
        {
          img: require("../../../assets/ssrs.png"),
          mainTitle: "学术人生",
          message: "在线预订 每期更新",
          goNext: "/consulting",
        },
      ],
      tu: [], //轮播图

      list2: [
        {
          img: require("../../../assets/xzzz.png"),
          title: "杂志动态",
          id: 1,
        },
        {
          img: require("../../../assets/zt.png"),
          title: "专题报告",
          id: 2,
        },
        {
          img: require("../../../assets/xzz.png"),
          title: "阜外说心脏",
          id: 3,
        },
        {
          img: require("../../../assets/zn.png"),
          title: "指南共识",
          id: 4,
        },
      ], //期刊收录
      contentId: "",
      channelId: "",
    };
  },
  methods: {
    linkUrl(url) {
      if (url) {
        window.open(url);
      }
    },
    //初始化页面
    index() {
      this.GetHomePagePicture(1865);
      for (var i = 0; i < this.title.length; i++) {
        if (i == 0) {
          this.title[i].zt = true;
          this.title.push("1");
          this.title.pop("1");
        } else {
          this.title[i].zt = false;
          this.title.push("1");
          this.title.pop("1");
        }
      }
    },

    goNext(title, nextGo, item) {
      if (title == "学术人生") {
        this.$router.push({ path: "/consulting" });
      } else if (item.path) {
        this.$router.push({ path: item.path });
      } else {
        window.open(nextGo);
      }
    },

    addtop(num, id, index) {
      this.$refs.carousel.setActiveItem(index);
      this.mrIndex = index;
      if (num == 1) {
        for (var i = 0; i < this.list2.length; i++) {
          if (id == this.list2[i].id) {
            // if(this.mrIndex==index){
            // this.list2[i].zt = true;
            // }

            this.list2[i].zt = true;
            this.list2.push("1");
            this.list2.pop("1");
          }
        }
      } else {
        for (var i = 0; i < this.list2.length; i++) {
          this.list2[i].zt = false;
          this.list2.push("1");
          this.list2.pop("1");
        }
      }
    },

    GetHomePagePicture(channelId) {
      var that = this;
      that.$httphelper
        .GetHomePagePicture({
          journalId: 201607080003,
          channelId: channelId,
        })
        .then((res) => {
          console.log(res, "去围棋无");
          if (res.code == 200) {
            that.tu = res.data || "";
            that.$loading.hideLoading();
          } else {
          }
        });
    },
  },
  computed: {
    optionLeft() {
      return {
        limitMoveNum: 8,
        direction: 1,
      };
    },
  },
  created() {
    this.index();
  },
};
</script>

<style lang="scss" scoped>
.author {
  width: 100%;
  min-width: 1366px;
  background-color: #f7f8fa;
  padding-top: 40px;
  .author_nav {
    width: 78%;
    margin: 0 auto;
    overflow: hidden;

    .topTop {
      width: 100%;
      margin-bottom: 50px;
      position: relative;
      .banner {
        width: 60%;

        // border:3px solid #ccc;
        .imgggg {
          width: 100%;
          height: 100%;
        }

        /deep/ .el-carousel__button {
          height: 15px;
          width: 15px;
          border-radius: 50%;
          margin-left: 10px;
        }
      }
      .topRight {
        position: absolute;
        right: 80px;
        top: 0;
        width: 33%;
        height: 100%;
        background: rgba(225, 230, 242, 1);
        // background: #f9f9f9;

        .topMap {
          width: 100%;
          height: 15%;
          text-align: center;
          margin-top: 30px;
        }
        .topMain {
          width: 100%;
          img {
            float: left;
            height: 35px;
            margin: 10px 20px 0 50px;
          }
          li {
            width: 100%;
            //  border:1px solid #ccc;
            //  text-align: center;
            height: 55px;
            line-height: 55px;
            //  background-color: #FFFFFF;
            color: #2a2d3e;
            font-size: 18px;
            list-style-type: none;
            span {
              float: right;
              width: 10px;
              height: 18px;
              color: #606879;
              margin-right: 30px;
            }
          }
        }
      }
    }

    .phone {
      float: left;
      width: 13%;
      // border: 1px solid #ccc;
      // margin-left: 30px;
      padding-left: 25px;
      // border:1px solid #ccc;
      text-align: center;
    }

    .phone:nth-of-type(5) {
      margin-right: 40px;
    }
    .phone:nth-of-type(6) {
      margin-left: 20px;
    }
  }
}
.add1 {
  color: var(--xt) !important;
  text-decoration: underline;
}
.add2 {
  background-color: #ffffff !important;
}
.addtxt {
  font-weight: bold !important;
  font-size: 20px !important;
}
.xian {
  border-bottom: 3px solid var(--xt) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/public/home/clickSkip.vue